import { render, staticRenderFns } from "./BaseSidebar.vue?vue&type=template&id=3acaa0d4&scoped=true&"
import script from "./BaseSidebar.vue?vue&type=script&lang=js&"
export * from "./BaseSidebar.vue?vue&type=script&lang=js&"
import style0 from "./BaseSidebar.vue?vue&type=style&index=0&id=3acaa0d4&scoped=true&lang=scss&"
import style1 from "./BaseSidebar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acaa0d4",
  null
  
)

export default component.exports